module.exports = __webpack_public_path__ + "static/media/illustration_doctors.19213887.png";